import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Contract.ListWithLegacy.IRequest;
type Response = Api.Core.Contract.ListWithLegacy.IResponse;
type Headers = Api.Core.Contract.ListWithLegacy.IHeaders;
const url = '/api/Sales/Contract/GetContractsWithLegacy';
export default async function contractListWithLegacyApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
